














interface LocalState {
  active: boolean;
  type: 'border-active' | 'text-active';
}
interface LocalProps {
  name: PropOptions;
}

import Vue, { PropOptions } from 'vue';
export default Vue.extend({
  name: 'HMTab',
  props: {
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'border-active',
    },
  } as LocalProps,
  data(): LocalState {
    return {
      active: false,
    };
  },
  methods: {
    onClick(): void {
      this.$parent.selectTab(this.name);
    },
  },
  watch: {
    '$parent.value': {
      handler(value: string) {
        this.active = this.$parent.value === this.name;
      },
      immediate: true,
    },
  },
});
